import { createContext, useReducer, useState } from "react";

export const MensajeContActualizacion=createContext<any>("");

const reducer=(state:any,action:any):string=>
{
    return action.input;
}

export const MensajeActualizacionCon=({children}:any)=>
{
    const [MensajeContexActualizacion,dispatch]=useReducer(reducer,"");

    const ActualizacionMensajeActualizacion=(number:string)=>
    {
        dispatch({input:number})
    }
    const [MensajeEmergente,SetMensajeEmergente]=useState<string>("")

    const [CasillaCalculadora,SetCasillaCalculadora]=useState<string>("")

    const [MensPreferencia,SetMensPreferencia]=useState<string>("")

    const [Loadings,SetLoading]=useState<boolean>(false)
    
    const [BusquedaShow,SetBusquedaShow]=useState<String>("Rastreo")

    const [ActivoPreAlerta,SetActivoPreAlerta]=useState<boolean>(false)

    const [CambiosCantidad,SetCambiosCantidad]=useState<number>(0)

    const [Redireccion,SetRedireccion]=useState<boolean>(false)
    const [MensajeEmergenteGoogle,SetMensajeEmergenteGoogle]=useState<string>("")

    const [ElimnarPrealertas,SetElimnarPrealertas]=useState<boolean>(false)
    const [Id,SetId]=useState<number>(0)
    const [Id2,SetId2]=useState<number>(0)

    return (
        <MensajeContActualizacion.Provider value={{MensajeContexActualizacion,ActualizacionMensajeActualizacion,MensPreferencia,SetMensPreferencia,SetMensajeEmergente,MensajeEmergente,CasillaCalculadora,SetCasillaCalculadora,SetLoading,Loadings,BusquedaShow,SetBusquedaShow,ActivoPreAlerta,SetActivoPreAlerta,CambiosCantidad,SetCambiosCantidad,Redireccion,SetRedireccion,MensajeEmergenteGoogle,SetMensajeEmergenteGoogle,ElimnarPrealertas,SetElimnarPrealertas,Id,SetId,Id2,SetId2}}>
            {children}
        </MensajeContActualizacion.Provider>
    )
}